import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectBackWallTypeForm,
  selectBackWallTypeSaving,
  selectCanSubmitBackWallType,
  selectIsAddModalOpen,
} from "../../redux/selector";
import { backWallTypeActions } from "../../redux/slice";
import { BackWallTypeForm } from "../../types";
import { useStyles } from "./styles";

const P = "BACK_WALL_TYPE.MODAL";

const AddBackWallTypeModal = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const open = useSelector(selectIsAddModalOpen);
  const form = useSelector(selectBackWallTypeForm);
  const saving = useSelector(selectBackWallTypeSaving);
  const canSubmit = useSelector(selectCanSubmitBackWallType);

  const onClose = () => {
    if (saving) return;
    dispatch(backWallTypeActions.closeAddModal());
  };

  const setField = (name: keyof BackWallTypeForm, value: string) =>
    dispatch(backWallTypeActions.setFormField({ name, value }));

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>{t(`${P}.ADD_TITLE`)}</Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t("BUTTONS.CANCEL")}
            disabled={saving}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <Box className={styles.field}>
            <Typography className={styles.label}>{t(`${P}.FIELDS.CODE`)}</Typography>
            <TextField
              className={styles.input}
              fullWidth
              variant="outlined"
              placeholder={t(`${P}.PLACEHOLDERS.ENTER_CODE`)}
              value={form.backWallCode}
              disabled={saving}
              InputProps={{ notched: false }}
              onChange={(event) => setField("backWallCode", event.target.value)}
            />
          </Box>

          <Box className={styles.field}>
            <Typography className={styles.label}>
              {t(`${P}.FIELDS.DESCRIPTION`)}
            </Typography>
            <TextField
              className={styles.input}
              fullWidth
              variant="outlined"
              placeholder={t(`${P}.PLACEHOLDERS.ENTER_DESCRIPTION`)}
              value={form.backWallDesc}
              disabled={saving}
              InputProps={{ notched: false }}
              onChange={(event) => setField("backWallDesc", event.target.value)}
            />
          </Box>

          <Box className={styles.field}>
            <Typography className={styles.label}>
              {t(`${P}.FIELDS.PROTRUSION`)}
            </Typography>
            <TextField
              className={styles.input}
              fullWidth
              variant="outlined"
              placeholder={t(`${P}.PLACEHOLDERS.ENTER_PROTRUSION`)}
              value={form.bump}
              disabled={saving}
              InputProps={{ notched: false }}
              onChange={(event) => setField("bump", event.target.value)}
            />
          </Box>
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={onClose}
            disabled={saving}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!canSubmit || saving}
            onClick={() => dispatch(backWallTypeActions.addBackWallType())}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddBackWallTypeModal;
